import { asPage } from 'src/components/hoc/asPage'
import { NeedsEditor } from 'src/compositions/Profile/Needs'

export default asPage(NeedsEditor, { pageTitle: 'ニーズの編集' })
